import { useState } from "react";

/**
 * Hook personalizado para manejar notificaciones snackbar
 */
export const useSnackbar = () => {
  const [snackOpen, setSnackOpen] = useState(false);
  const [snackMsg, setSnackMsg] = useState("");
  const [snackSeverity, setSnackSeverity] = useState("success");

  const showSnackbar = (message, severity = "success") => {
    setSnackMsg(message);
    setSnackSeverity(severity);
    setSnackOpen(true);
  };

  const closeSnackbar = () => {
    setSnackOpen(false);
  };

  return {
    snackOpen,
    snackMsg,
    snackSeverity,
    showSnackbar,
    closeSnackbar,
  };
};

